import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import { useFormik } from 'formik'
import qs from 'qs'
import { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { sendConfirmationEmail } from '@email/actions'
import { Message } from '@components/shared/Message'

const ResendEmail = () => {
    
    const navigate = useNavigate()
    
    const [email, setEmail] = useState('')
    const [message, setMessage] = useState()
    const [newEmail, setNewEmail] = useState('')
    
    const userExists = useWireValue(store.userExists)
    
    const formik = useFormik({
        initialValues: { newEmail: '' },
        onSubmit: async values => {
            setMessage(undefined)
            
            if (!values.newEmail) {
                setMessage({
                    text: 'Please fill in the new email.',
                    level: 'danger',
                })
            } else {
                await actions.checkUserExists(values.newEmail)
                await setNewEmail(values.newEmail)
            }
        },
    })
    
    const sendEmail = useCallback(
        async (email, to) => {
            await sendConfirmationEmail(email, to)
        },
        [],
    )
    
    useEffect(() => {
        if (userExists === true) {
            if (email !== newEmail) {
                setMessage({ text: 'User already exists in the system.', level: 'danger' })
            } else {
                if (newEmail) {
                    sendEmail(email, newEmail)
                    navigate(`/emailsent?email=${newEmail}`)
                }
            }
        } else {
            if (newEmail) {
                sendEmail(email, newEmail)
                
                if (email !== newEmail) {
                    actions.updateUserEmail(email, newEmail)
                }
                
                navigate(`/emailsent?email=${newEmail}`)
            }
        }
    }, [newEmail, email, sendEmail, userExists])
    
    const location = useLocation()
    
    useEffect(() => {
        let email = qs.parse(location.search, { ignoreQueryPrefix: true }).email
        
        if (typeof email === 'string') {
            setEmail(email)
        }
    }, [location])
    
    const { handleSubmit, handleChange } = formik
    
    return (
        <div className="flex flex-col justify-center items-center" style={{ height: '99vh' }}>
            <div className="w-96 mx-auto">
                <div
                    style={{
                        marginBottom: '25px',
                        width: '80%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: '0 auto 20px',
                    }}>
                    <img src="img/logo.png" width="100%" height="100%" alt="" />
                </div>
                {message && <Message message={message} />}
                <div className="text-center">
                    <h2>Can&apos;t see the confirmation email?</h2>
                    <p>We sent it to {email.toLowerCase()}.</p>
                    <p>Try checking again in a minute, or check your spam folder or request another email here:</p>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <p className="mb-2 text-muted">Confirm email address (Required)</p>
                            <input
                                type="email"
                                name="newEmail"
                                id="newEmail"
                                className="input input-bordered w-full"
                                onChange={handleChange}
                                placeholder="example@email.com"/>
                        </div>
                        <div className="mb-2 mt-4 form-group">
                            <div className="input-group input-group-merge ">
                                <input
                                    type="submit"
                                    value="Resend Email"
                                    className="mb-3 btn btn-lg btn-block btn-primary btn-outline"/>
                            </div>
                        </div>
                    </form>
                    <span
                        className="text-muted"
                        style={{ cursor: 'pointer' }}
                        onClick={() => navigate('/signup')}>
                        Back to sign up
                    </span>
                </div>
            </div>
        </div>
    )
}

export default ResendEmail
